import { render, staticRenderFns } from "./question-4.vue?vue&type=template&id=10ade1a6&scoped=true"
import script from "./question-4.vue?vue&type=script&lang=js"
export * from "./question-4.vue?vue&type=script&lang=js"
import style0 from "./question-4.vue?vue&type=style&index=0&id=10ade1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ade1a6",
  null
  
)

export default component.exports